(function () {
  document.querySelectorAll('[data-grab-scroll]:not([data-grab-initialized])').forEach(function (list) {
    list.setAttribute('data-grab-initialized', '');

    var isDown = false;
    var startX;
    var scrollLeft;
    var hasMoved = false;

    list.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    list.addEventListener('mousedown', function (e) {
      isDown = true;
      hasMoved = false;
      list.classList.add('is-grabbing');
      startX = e.pageX;
      scrollLeft = list.scrollLeft;
    });

    list.addEventListener('mouseleave', function () {
      isDown = false;
      list.classList.remove('is-grabbing');
    });

    list.addEventListener('mouseup', function () {
      isDown = false;
      list.classList.remove('is-grabbing');
    });

    list.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var walk = e.pageX - startX;
      if (Math.abs(walk) > 5) hasMoved = true;
      list.scrollLeft = scrollLeft - walk;
    });

    list.addEventListener('click', function (e) {
      if (hasMoved) {
        e.preventDefault();
        e.stopPropagation();
        hasMoved = false;
      }
    }, true);
  });
})();
